import React, { useState } from 'react';
import ClientTableRow from './components/ClientTableRow';
import { DESK_GROUP_COMPANY_SETTING_SEARCH } from 'src/constants/EndpointUrls';
import { concatParamsToUrl, redirectTo } from 'src/utils/Http';
import ClientPagination from '../Clients/components/ClientPagination';
import { DESK_GROUP_COMPANY_SETTING_PAGINATE } from 'src/constants/EndpointUrls';

const GroupCompanySettings = props => {
  const clients = props.clients;
  const clientPerPage = props.clientPerPage;
  const currentPage = props.currentPage;
  const totalClients = props.totalClients;

  const [search, setSearch] = useState("");

  const setSearchTerm = e => {
    setSearch(e.target.value);
    e.preventDefault();
  };

  const handleSubmit = search => {
    redirectTo(concatParamsToUrl(DESK_GROUP_COMPANY_SETTING_SEARCH, { q: search }))
  };

  return (
    <React.Fragment>
      <h2>Group Company Settings</h2>
      <div className="form-inline">
        <div className="mr-2 d-flex p-3">
          <label className="mr-1" htmlFor="q">Client Name: </label>
          <input className="mr-1" id="q" name="q" type="text" onChange={setSearchTerm} />
          <button className="form-control btn btn-primary" onClick={() => {handleSubmit(search)}}>Search</button>
        </div>
      </div>
      <ClientPagination clientPerPage={clientPerPage} currentPage={currentPage} totalClients={totalClients} url={DESK_GROUP_COMPANY_SETTING_PAGINATE} />
      <table className='table table-striped'>
        <thead>
          <tr>
            <th>ID</th>
            <th>Client Name</th>
            <th>Display</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {clients.map(client => (
            <ClientTableRow
              key={client.id}
              client={client}
            />
          ))}
        </tbody>
      </table>
    </React.Fragment>
  );
};

export default GroupCompanySettings;